import { Box, Text } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { getSelectedDashboardScenario, getTimeFilter } from 'redux/DashboardSliceV2';

import { PageInstruments } from './Instruments/proptypes';
import PageGrid from './PageGrid';

export interface PreviewProperties {
  selectedPages: any[];
  allPageInstruments: PageInstruments;
  allInstrumentsData: PageInstruments;
  isPageDataLoading: boolean;
  isPageInstrumentsLoading: boolean;
}

const Preview = ({
  selectedPages,
  allPageInstruments,
  allInstrumentsData,
  isPageDataLoading,
  isPageInstrumentsLoading,
}: PreviewProperties) => {
  const selectedScenario = useSelector(getSelectedDashboardScenario);
  const timeFilter = useSelector(getTimeFilter);
  if (isPageDataLoading || isPageInstrumentsLoading) {
    return <Box>Loading preview...</Box>;
  }

  return (
    <Box width='100%' display='flex' flexDirection='column' alignItems='center'>
      {selectedPages
        .sort((a: any, b: any) => a.position - b.position)
        .map((page, index) => (
          <Box
            key={page.id}
            className={`page-container page-${page.id} ${index === 0 ? '' : 'page-break'}`}
            data-page-number={`Page ${index + 1} of ${selectedPages.length}`}
          >
            <Text fontWeight='bold' mb={page?.description ? 0 : 2} color='black' fontSize='xl'>
              {page.name}
            </Text>
            {page.description && (
              <Text color='black' fontSize='md'>
                {page.description}
              </Text>
            )}
            <Text fontSize='12px' color={'black'} cursor='pointer' mb={1}>
              {`Scenario: ${selectedScenario?.name || 'No scenario selected'} | Period: ${
                timeFilter?.start || 'N/A'
              } - ${timeFilter?.end || 'N/A'}`}
            </Text>
            <PageGrid
              page={page}
              allInstruments={allPageInstruments[page.id] || []}
              allInstrumentsData={allInstrumentsData[page.id] || []}
            />
          </Box>
        ))}
    </Box>
  );
};

export default Preview;
